<h3 mat-dialog-title>Ajouter une citation</h3>

<div mat-dialog-content>
  <form class="dialog-form create-form" [formGroup]="createForm" (ngSubmit)="onSubmit()">
    <mat-form-field>
      <textarea minRosw="2" matInput placeholder="Citation" aria-label="Citation" formControlName="quote"></textarea>
      @if (submitted && createForm.get('quote').invalid) {
      <mat-error>Champ requis</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <input type="text" placeholder="Auteur" aria-label="Auteur" matInput formControlName="author"
        [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="display">
        @for (option of filteredOptions | async; track option.id) {
        <mat-option [value]="option">
          {{option.name}}
        </mat-option>
        }
      </mat-autocomplete>
      @if (submitted && createForm.get('author').invalid) {
      <mat-error>Champ requis</mat-error>
      }
    </mat-form-field>

    <button type="submit" mat-flat-button color="primary" [disabled]="loading">Créer la citation</button>
  </form>
</div>
